import { MobXProviderContext } from "mobx-react";
import { Instance, types } from "mobx-state-tree";
import { useContext } from "react";
import { FileUploadStore } from "@fidget/common/models/files/FileUploadStore";
import { ProfanityStore } from "@fidget/common/models/profanities/ProfanityStore";
import { FeaturesStore } from "@fidget/common/models/features/FeaturesStore";
import { extendsSharedRootStore, SharedRootStoreEnv } from "@fidget/common/models/shared/sharedEnv";
import { ForeContext } from "../context";
import { IForeSpinnerService } from "../services/spinnerService";
import { ForeCallModel } from "./call/foreCallModel";
import { ContextStore } from "./context/contextStore";
import { UiStore } from "./ui/UiStore";
import { FingerprintStore } from "./fingerprint/FingerprintStore";
import { ForeServices } from "../services/foreServices";
import { ForeCallService } from "../services/ForeCallService";

export const ForeRootStore = types.model("ForeRootStore", {
  foreCallStore: ForeCallModel,
  uiStore: UiStore,
  profanityStore: ProfanityStore,
  contextStore: ContextStore,
  fileStore: FileUploadStore,
  fingerprintStore: FingerprintStore,
  featuresStore: FeaturesStore
});

export interface ForeRootStoreEnv extends SharedRootStoreEnv, ForeServices {
  spinnerService: IForeSpinnerService;
  foreContext: ForeContext;
  callService: ForeCallService;
}

export const useStore = (): IForeRootStore => {
  const store = useContext(MobXProviderContext);

  if (!store) {
    throw new Error("useStore must be used withing a StoreProvider");
  }

  return store as IForeRootStore;
};

export const useForeContext = (): ForeContext => {
  const { contextStore } = useStore();
  return contextStore.foreContext;
};

export interface IForeRootStore extends Instance<typeof ForeRootStore> {}

/** Verify fore root store model extends shared store */
// ignore unused function
// @ts-ignore
const checkThatForeRootStoreExtendsSharedRootStore = (t: IForeRootStore) => {
  extendsSharedRootStore(t);
};
